import { useLayoutStore } from "@/stores/layoutStore";
import { getHolidayInfo } from "@/utils/holidayUtils";

/**
 * 고객센터 연결 관련 composable
 * - 공휴일 체크 및 팝업 표시
 * - 전화 연결
 * - 카카오 채팅 연결
 */
export function useCustomerSupport() {
  const layoutStore = useLayoutStore();

  /**
   * 카카오 채널 채팅 열기
   */
  const openKakaoChat = () => {
    const url = "http://pf.kakao.com/_uZzxfG/chat";

    if (window.flutter_inappwebview) {
      window.flutter_inappwebview.callHandler("openBrowser", { url });
    } else {
      window.open(url);
    }
  };

  /**
   * 고객센터 전화 연결
   */
  const callCustomerCenter = () => {
    if (window.flutter_inappwebview) {
      window.flutter_inappwebview.callHandler("call", {
        contract: "1660-3114",
      });
    } else {
      document.location.href = "tel:1660-3114";
    }
  };

  /**
   * 고객센터 연결 버튼 클릭 핸들러
   * - 공휴일: 안내 팝업 표시
   * - 평일: 전화/채팅 선택 다이얼로그 표시
   */
  const onClickCustomerSupportButton = () => {
    const holidayInfo = getHolidayInfo();

    if (holidayInfo.isHoliday) {
      // 공휴일 안내 팝업 (날짜별 커스텀 타이틀/메시지)
      layoutStore.showAlertDialog(
        holidayInfo.title,
        holidayInfo.message,
        "확인",
        () => {},
        "text-[#3182FF]",
      );
      return;
    }

    // 기존 다이얼로그 (전화/채팅 선택)
    layoutStore.showConfirmDialog(
      "고객센터로 연결합니다",
      "바로 연결하시겠습니까?",
      "전화하기",
      null,      
      () => callCustomerCenter(),
      null,
      "text-[#3182FF]",
    );
  };

  return {
    onClickCustomerSupportButton,
    openKakaoChat,
    callCustomerCenter,
  };
}
